import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  CmsBannerCarouselComponent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  CmsLinkComponent,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Country,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  HttpErrorModel,
  Price,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product,
  SearchState
} from '@spartacus/core';
import { LAUNCH_CALLER } from '@spartacus/storefront';

import { RelatedPartType } from '@app/core/types/backend/related-part-type.type';
import { Surcharge } from '@app/core/types/backend/surcharge.type';
import { FACET_SPECIALS } from '@app/core/types/facet-spetials.type';
import { DpRelatedParts } from '@app/core/types/view/dp-products-details.interface';
import { DeliveryModeOptions } from '@app-modules/checkout/modules';
import { OrderDelivery } from '@app-modules/order/order-details/types/order-delivery.type';
import { FacetCategory } from '@app-modules/product/product-facet-navigation/types';
import { MeasurementSystem } from '@app-modules/site-context/types/measurement-system.type';

declare module '@spartacus/core' {
  interface BaseStore {
    checkoutDeliveryStep?: boolean;
    termsAndConditions?: boolean;
    orderEntryAdditionalFields?: string[];
    showContact?: boolean;
    showDistributors?: boolean;
    requiredPurchaseOrderNumber?: boolean;
    excludeTaxOnCheckout?: boolean;
  }

  interface BaseSite {
    orderEntryAdditionalFields?: string[];
    productCatalog?: { id: string };
    defaultMeasurementSystem?: Pick<MeasurementSystem, 'code'>;
  }

  interface Product {
    brandName?: string;
    relatedPartTypes?: RelatedPartType[];
  }

  interface Price {
    formattedRawValue?: string;
  }

  interface User {
    erpId: string;
    market: string;
    country: Country;
    measurementSystem?: MeasurementSystem;
  }

  interface ProductSearchPage {
    facetCategories: FacetCategory[];
  }

  interface Country {
    market: string;
  }

  interface CmsLinkComponent {
    localizedUrl?: string;
    javaScript?: string;
  }

  interface CmsBannerComponent {
    localizedUrl?: string;
    pageLabelOrId?: string;
  }

  interface CmsBannerCarouselComponent {
    timeout: number;
  }

  interface ProductSearchPage {
    relatedParts?: DpRelatedParts[];
  }

  interface Facet {
    specialFacetType?: FACET_SPECIALS;
    facetCode?: string;
    query?: SearchState;
  }

  interface Breadcrumb {
    facetCategoryCode?: string;
  }

  interface Page {
    metaTitle?: string;
  }

  interface PageMeta {
    metaTitle?: string;
  }

  interface ProductSearchPage {
    relatedParts?: DpRelatedParts[];
  }

  interface Facet {
    specialFacetType?: FACET_SPECIALS;
    facetCode?: string;
    query?: SearchState;
  }

  interface Breadcrumb {
    facetCategoryCode?: string;
  }

  interface Address {
    searchTerm?: string;
    name2?: string;
    name3?: string;
    fax?: string;
  }

  interface PointOfService {
    jobTitle?: string;
    website?: string;
    type: string;
    distance?: number;
  }

  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Occ {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    interface BaseStore {
      deliveryCountries?: Country[];
      checkoutDeliveryStep?: boolean;
      termsAndConditions?: boolean;
      open?: boolean;
      showContact?: boolean;
      showDistributors?: boolean;
    }

    interface Image {
      featureDescription?: string;
    }

    interface CMSPage {
      metaTitle?: string;
    }

    interface FeatureValue {
      icon?: Occ.Image;
    }

    interface Feature {
      id?: string;
      featureDescription?: string;
    }
  }
}

declare module '@spartacus/cart/base/root' {
  interface Cart {
    openText?: string;
    totalListPrice?: Price;
    totalRelativeDiscount?: number;
    surcharges?: Surcharge[];
  }

  interface CartModification {
    ordinalNumber?: number;
    productCode?: string;
  }

  interface DeliveryMode {
    options: DeliveryModeOptions[];
  }

  interface OrderEntry {
    deliveries?: OrderDelivery[];
    status?: string;
    requestedDeliveryDate?: string | null;
    defaultWarehouseStockAmount?: number;
  }
}

declare module '@spartacus/checkout/base/root' {
  export interface CheckoutStep {
    nextStepLabel?: string;
    previousStepLabel?: string;
  }
}

declare module '@spartacus/storefront' {
  /* eslint-disable */
  enum LAUNCH_CALLER {
    CONTRACT_CODE = 'CONTRACT_CODE',
    FACET_CATEGORY_PANEL = 'FACET_CATEGORY_PANEL',
    PRODUCT_CATEGORY_SELECTOR_PANEL = 'PRODUCT_CATEGORY_SELECTOR_PANEL',
    EDIT_ADDRESS = 'EDIT_ADDRESS'
  }

  /* eslint-enable */

  interface NavigationNode {
    uid?: string;
    javaScript?: string;
    localizedUrl?: string;
  }

  interface Card {
    isDefaultAddress?: boolean;
  }
}
/* eslint-disable */
(LAUNCH_CALLER as any)['CONTRACT_CODE'] = 'CONTRACT_CODE';
(LAUNCH_CALLER as any)['FACET_CATEGORY_PANEL'] = 'FACET_CATEGORY_PANEL';
(LAUNCH_CALLER as any)['PRODUCT_CATEGORY_SELECTOR_PANEL'] = 'PRODUCT_CATEGORY_SELECTOR_PANEL';
(LAUNCH_CALLER as any)['EDIT_ADDRESS'] = 'EDIT_ADDRESS';
(LAUNCH_CALLER as any)['PRODUCT_IMAGE_ZOOM'] = 'PRODUCT_IMAGE_ZOOM';
/* eslint-enable */
